import React from 'react';
import PropTypes from 'prop-types';
import ChannelKey from '@avtechsoftware/ra-javascript-utilities/src/classes/ChannelKey';
import { useSelector } from 'react-redux';
import ChannelService
  from '@avtechsoftware/ra-javascript-utilities/src/utilities/channels/ChannelService';
import { SystemCommentType } from '../../../../../../utility/types/SystemCommentType';
import formatTimestamp from '../../../../../../utility/formatTimestamp';
import AlertSystemCommentBody from './AlertSystemCommentBody/AlertSystemCommentBody';
import { selectSessionInformation } from '../../../../../../redux/slices/sessionSlice';

const formatReading = (value, channelKeyObject, scaleOptions) => {
  const channel = ChannelService.getChannelFromChannelKeyObject(channelKeyObject);
  if (!channel) return value;
  return `${channel.getDisplayValue(value, scaleOptions)} ${channel.getUnits(scaleOptions)}`;
};

const createSystemComment = (contextData, temperatureScale, airSpeedScale) => {
  const channelKeyObject = new ChannelKey(contextData.channelKey);
  const scaleOptions = { temperatureScale, airSpeedScale };
  const lastReadingText = `Last Reading: ${formatReading(contextData.value, channelKeyObject, scaleOptions)}`;

  switch (parseInt(contextData.type, 10)) {
    case SystemCommentType.TRIGGER:
      return (
        <AlertSystemCommentBody
          title="Alert **TRIGGERED**"
          lastReading={lastReadingText}
          triggered={`Triggered: ${formatTimestamp(contextData.triggeredTimestamp)}`}
        />
      );
    case SystemCommentType.CLEAR:
      return (
        <AlertSystemCommentBody
          title="Alert **CLEARED**"
          triggered={`Triggered: ${formatTimestamp(contextData.triggeredTimestamp)}`}
          cleared={`Cleared: ${formatTimestamp(contextData.clearedTimestamp)}`}
          duration={`Duration: ${contextData.duration}`}
          lastReading={lastReadingText}
        />
      );
    case SystemCommentType.ACKNOWLEDGED:
      return (
        <AlertSystemCommentBody
          title="Alert **ACKNOWLEDGED**"
          triggered={`Triggered: ${formatTimestamp(contextData.triggeredTimestamp)}`}
          acknowledge={`Acknowledged: ${formatTimestamp(contextData.acknowledgedTimestamp)}`}
          duration={`Duration: ${contextData.duration}`}
          lastReading={lastReadingText}
        />
      );
    default:
      return null;
  }
};

function AlertSystemComment(props) {
  const { temperatureScale, airSpeedScale } = useSelector(selectSessionInformation);

  const {
    text,
  } = props;

  return (
    <>
      <>
        <p className="mb-1"><b>Room Alert</b></p>
        <p className="mb-0"><text>{createSystemComment(JSON.parse(text), temperatureScale, airSpeedScale)}</text></p>
      </>
    </>
  );
}

AlertSystemComment.propTypes = {
  text: PropTypes.string.isRequired,
  // timestamp: PropTypes.number.isRequired,
};

export default AlertSystemComment;
